import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { LiveChatResponse } from "@obg/ngx.common/types";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[Support]";

export const SUPPORT_ACTION_TYPE = {
	getLiveChatUrl: `${ACTION_PREFIX} Get Live Chat Url`,
	getLiveChatUrlSuccess: `${ACTION_PREFIX} Get Live Chat Url Success`,
	getLiveChatUrlFail: `${ACTION_PREFIX} Get Live Chat Url All Fail`,
};

@Injectable({
	providedIn: "root",
})
export class SupportAction {
	getLiveChatUrl(): Action {
		return {
			type: SUPPORT_ACTION_TYPE.getLiveChatUrl,
		};
	}

	getLiveChatUrlSuccess(liveChat: LiveChatResponse): ActionWithPayload {
		return {
			type: SUPPORT_ACTION_TYPE.getLiveChatUrlSuccess,
			payload: liveChat,
		};
	}

	getLiveChatUrlFail(error: AppError): ActionWithPayload {
		return {
			type: SUPPORT_ACTION_TYPE.getLiveChatUrlFail,
			payload: error,
		};
	}
}
